<template>
  <article class="step-one" >

    <div class="tabs">

      <button
        class="button navy-border"  :class="{ 'active' : current_tab === tab.title }"
        v-for="tab of memberships"
        @click="changeTab(tab.title)"
      >
        {{ tab.title }}
      </button>

    </div>

    <div
      class="tab personal" :class="{ 'active' : current_tab === tab.title }"
      v-for="tab of memberships"
    >

      <div class="type flex"
        v-for="membership of tab.memberships"
      >
        <div class="title">
          <h3>{{ membership.title }}</h3>
          <p>{{ membership.data.subtitle }}</p>

          <div class="special" v-if="membership.data.special_text_title !== '' && membership.data.special_text !== ''">
            <p class="top">{{membership.data.special_text_title}}</p>
            <div class="offer">
              <p v-html="membership.data.special_text.replace(/(?:\r\n|\r|\n)/g, '<br />')"></p>
            </div>
          </div>

        </div>
        <div class="content wysiwyg">
          <ul>
            <li v-for="feature of membership.features">{{ feature.title }}</li>
          </ul>
        </div>
        <div class="price">
          <p v-if="membership.lowest_price !== '0.00'">From <strong>${{ membership.lowest_price }} / week</strong></p>
          <p class="note" v-if="membership.data">{{ membership.data.sub_lower_price }}</p>

          <div
            class="button light-blue"
            @click="finishStepOne(membership.terms, membership.data.terms)"
          >
            Join Now
          </div>
        </div>
      </div>


    </div>


  </article>
</template>

<script>
export default {
  props: {
    memberships: Array,
  },
  data () {
    return {
      current_tab: 'Personal Memberships'
    };
  },
  mounted () {
    let url = new URL(window.location.href)
    let tab = url.searchParams.get('tab')

    if (tab) {
      console.log('type', tab)
      let current = this.memberships.find(obj => obj.title === tab)
      this.changeTab(current.title)
    }
  },
  methods: {
    changeTab (tab) {
      this.current_tab = tab
      let url = '?tab=' + tab
      history.pushState(this.payload, '', '/personal/personal-fitness/memberships' + url)
    },

    finishStepOne (terms, term_terms) {
      console.log(terms)
      this.$emit('membershipTerms', terms, term_terms)
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/memberships/StepOne.vue